import React, { FunctionComponent, useCallback, useEffect, useMemo, useState } from 'react'
import { AutoComplete, Button, Input } from 'antd'
import {
  CloseOutlined,
  HolderOutlined,
  LoadingOutlined,
  SearchOutlined
} from '@ant-design/icons'
import { useFeathersClient } from '@strac/react-client-feathers'
import debounce from 'lodash/debounce'

interface IProps {
  removeItem: () => void
}

interface Option {
  value: string
  label: string
  place_id: string
}

type SetStateAction<T> = T | ((prevState: T) => T);

const SearchInput: FunctionComponent<any> = (props: IProps) => {
  const { removeItem } = props

  const [options, setOptions] = useState<Option[]>([])

  const client = useFeathersClient()

  const [loading, setLoading] = useState<boolean>(false)
  const [placeDetails, setPlaceDetails] = useState<google.maps.places.PlaceResult | undefined>(undefined)

  console.log('placeDetails', placeDetails)

  // Wrap the handler with debounce
  const debouncedSearch = useMemo(() => {
    const fn = (value: string, setOptions: SetStateAction<any>) => {
      if (!value) {
        setOptions([])
        return
      }

      const service = new window.google.maps.places.AutocompleteService()
      setLoading(true)
      service.getPlacePredictions({ input: value }, (predictions) => {
        console.log('predictions', predictions)
        const newOptions =
          predictions?.map((p) => ({
            value: p.description,
            label: p.description,
            place_id: p.place_id
          })) || []
        setLoading(false)
        setOptions(newOptions)
      })
    }

    return debounce(fn, 300) // Adjust delay as needed
  }, [])

  const handleSearch = useCallback(
    (value: string) => {
      debouncedSearch(value, setOptions)
    },
    [debouncedSearch]
  )

  useEffect(() => {
    return () => {
      debouncedSearch.cancel() // Clean up on unmount
    }
  }, [debouncedSearch])

  const handleSelect = (placeId: string) => {
    setLoading(true)
    console.log('fire')
    client
      .service('google-maps-api')
      .find({
        query: {
          type: 'place-details',
          placeId
        }
      })
      .then((response: any) => {
        if (response.status === 'OK') {
          console.log(JSON.stringify(response.result))
          setPlaceDetails(response.result)
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false))
  }

  const handleAddonMouseDown = (e: React.MouseEvent) => {
    e.stopPropagation()
    e.preventDefault() // also useful to prevent focus
  }

  const addonBefore = (
    <div
      onMouseDown={handleAddonMouseDown}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 32,
        height: '100%',
        cursor: 'grab'
      }}
    >
      <HolderOutlined />
    </div>
  )

  return (
    <AutoComplete
      options={options}
      onSearch={handleSearch}
      style={{ width: '334px' }}
      onSelect={(value: string, option: Option) => handleSelect(option.place_id)}
    >
      <Input.Search
        style={{ width: '334px' }}
        placeholder={'Search Address'}
        suffix={<SearchOutlined />}
        addonBefore={addonBefore}
        enterButton={
          <Button
            type={'primary'}
            danger={true}
            icon={loading ? <LoadingOutlined /> : <CloseOutlined />}
            onClick={removeItem}
          />
        }
      />
    </AutoComplete>
  )
}

export default SearchInput
